import React, { ReactElement } from 'react'
import TextInput from '../formGroup/TextInput'
import Checkbox from '../formGroup/Checkbox'
import StepUploadWithValidateButton from '../upload/StepUploadWithValidateButton'
import { ALERT_MESSAGES } from '../../enums/common'
import YesNoButtons from '../formGroup/YesNoButtons'
import { IStep5WithUploadProps } from '../../interfaces/Step5'
import Step5NationaliteAmericaineHook from '../../hooks/Step5NationaliteAmericaineHook'
import { getItemSuffix } from '../../utils/getItemSuffix'

function Step5NationaliteAmericaine(
  props: IStep5WithUploadProps
): ReactElement {
  const {
    addState,
    removeState,
    form,
    folderData,
    stepUploadFileProps,
    state,
    step,
    item,
  } = props
  const { watch, register, errors, triggerValidation } = form
  const index = item ? 1 : 0

  const {
    nationaliteAmericaineTrue,
    showRadioNationaliteUsaLabelSecondForm,
    showRadioNationaliteUsaLabel,
    showRadioNeeUsaLabelSecondForm,
    showRadioNeeUsaLabel,
  } = Step5NationaliteAmericaineHook(props)
  const isNeeUsaSuffix = `is_nee_usa${getItemSuffix(item)}`
  const nationaliteAmericaineSuffix = `nationalite_americaine${getItemSuffix(
    item
  )}`
  const americanTaxInputSuffix = `american_tax_input${getItemSuffix(item)}`
  const attestationTinSuffix = `attestation_obntention_tin${getItemSuffix(
    item
  )}`
  const tinSuffix = `tin${getItemSuffix(item)}`

  const is_nee_usa = folderData[isNeeUsaSuffix]
  const watchIsNeeUsa: string = watch(isNeeUsaSuffix, is_nee_usa)
  const nationalite_americaine = folderData[nationaliteAmericaineSuffix]
  const watchNationaliteAmericaine: string = watch(
    nationaliteAmericaineSuffix,
    nationalite_americaine
  )
  const american_tax_input = folderData[americanTaxInputSuffix]
  const tin = folderData[tinSuffix]
  const attestation_obntention_tin = folderData[attestationTinSuffix]
  const nationaliteAmericaineFalse = watchNationaliteAmericaine === '1'
  const isNeeUsaTrue = nationaliteAmericaineFalse && watchIsNeeUsa === '0'
  const watchAmericanTaxInput: string = watch(
    americanTaxInputSuffix,
    american_tax_input
  )
  const americanTaxInputTrue =
    nationaliteAmericaineTrue && watchAmericanTaxInput === '0'
  const americanTaxInputFalse =
    nationaliteAmericaineTrue && watchAmericanTaxInput === '1'

  return (
    <div className="col12">
      <div className="mb0 mb1lg">
        <YesNoButtons
          id={nationaliteAmericaineSuffix}
          name={nationaliteAmericaineSuffix}
          label="Êtes-vous de nationalité américaine ?"
          value={nationalite_americaine || ''}
          register={register({ required: true })}
          labelClassName="mb15"
          disabled={
            item
              ? !showRadioNationaliteUsaLabelSecondForm
              : !showRadioNationaliteUsaLabel
          }
          error={errors[nationaliteAmericaineSuffix]}
          required
          onChange={(e: any) => {
            if (e.target.value === '0') {
              removeState?.(index)
            }
          }}
        />
      </div>
      <div className="row">
        {nationaliteAmericaineTrue && (
          <div className="colLg6 mb4lg mb05">
            <YesNoButtons
              id={americanTaxInputSuffix}
              name={americanTaxInputSuffix}
              label="Je dispose d’un Tax Identification Number (TIN) ?"
              value={american_tax_input || ''}
              register={register({ required: true })}
              labelClassName="mb15"
              error={errors[americanTaxInputSuffix]}
              required
            />
          </div>
        )}
        {americanTaxInputTrue && (
          <div className="colLg6">
            <TextInput
              register={register({
                required: true,
                pattern: {
                  value: /^[0-9\b]+$/,
                  message: ALERT_MESSAGES.tinInputPattern.message,
                },
                minLength: {
                  value: 9,
                  message: ALERT_MESSAGES.tinMinLength.message,
                },
                maxLength: {
                  value: 9,
                  message: ALERT_MESSAGES.tinMaxLength.message,
                },
              })}
              error={errors[tinSuffix]}
              name={tinSuffix}
              id={tinSuffix}
              defaultValue={tin || ''}
              label="Indiquez votre Tax Identification Number (TIN)"
              inputClassName="inputField inputFieldSecondary"
              placeHolder="Uniquement des caractères numériques"
              maxLength={9}
              required
              triggerValidation={triggerValidation}
            />
          </div>
        )}
        {americanTaxInputFalse && (
          <div className="col12 col10lg">
            <Checkbox
              label="J’atteste sur l’honneur que j’ai bien entrepris les démarches auprès des autorités américaines en vue de l’obtenir et je m’engage à le communiquer à Louvre Banque Privée dès que j’en aurai connaissance "
              id={attestationTinSuffix}
              name={attestationTinSuffix}
              checked={attestation_obntention_tin === '1' || false}
              register={register({ required: true })}
              error={errors[attestationTinSuffix]}
              labelClassName="fontWeightBold fontSizeSm fontStyleIt"
            />
          </div>
        )}
      </div>
      {nationaliteAmericaineFalse && (
        <div className="row">
          <div className="col12">
            <div className="mb0 mb2lg">
              <YesNoButtons
                id={isNeeUsaSuffix}
                name={isNeeUsaSuffix}
                label="Êtes-vous né(e) aux Etats-Unis ?"
                value={is_nee_usa || ''}
                register={register({ required: true })}
                labelClassName="mb15"
                disabled={
                  item ? !showRadioNeeUsaLabelSecondForm : !showRadioNeeUsaLabel
                }
                error={errors[isNeeUsaSuffix]}
                required
                onChange={(e: any) => {
                  if (e.target.value === '0') {
                    addState?.(index)
                  } else {
                    removeState?.(index)
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
      {isNeeUsaTrue && (
        <div className="row">
          {state[index] && (
            <div className="col12 colXl6">
              <StepUploadWithValidateButton
                {...{
                  ...stepUploadFileProps,
                  index,
                  title:
                    'Veuillez joindre la copie de votre certificat de perte ou de non-obtention de nationalité américaine',
                  step,
                  state,
                  item,
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default Step5NationaliteAmericaine
